document.addEventListener('DOMContentLoaded', () => {
    const tabBar = document.getElementById('pdp-tabs');
    const navWrapper = document.getElementById('pdp-nav');
    const tabLinks = document.querySelectorAll('.tab-link');
    const activeClass = 'tab-link--active';

    if (!tabBar || !navWrapper || tabLinks.length === 0) return;

    const setActiveTab = (targetHref) => {
        tabLinks.forEach(link => {
            link.classList.toggle(activeClass, link.getAttribute('href') === targetHref);
        });
    };

    tabLinks.forEach(link => {
        link.addEventListener('click', e => {
            const target = e.currentTarget;
            const targetHref = target.getAttribute('href');
            const targetSection = document.querySelector(targetHref);
            const offsetTop = targetSection.offsetTop - target.offsetHeight;

            if (targetSection) {
                e.preventDefault();
                $("html, body").animate({ scrollTop: offsetTop }, 400, "swing");
                setActiveTab(targetHref);
            }
        });
    });

    const sectionTargets = Array.from(tabLinks)
        .map(link => document.querySelector(link.getAttribute('href')))
        .filter(Boolean);

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setActiveTab(`#${entry.target.id}`);
            }
        });
    }, {
        threshold: 0,
        rootMargin: '-50% 0px -50% 0px'
    });

    sectionTargets.forEach(target => observer.observe(target));

    const handleStickyTabBar = () => {
        const stickyOffset = navWrapper.getBoundingClientRect().top + window.scrollY;

        if (window.scrollY >= stickyOffset) {
            tabBar.classList.add('is-sticky');
        } else {
            tabBar.classList.remove('is-sticky');
        }

        setStickyTabBarHeight();
    };

    const setStickyTabBarHeight = () => {
        navWrapper.style.height = window.getComputedStyle(tabBar).height;
    }

    handleStickyTabBar();
    window.addEventListener('scroll', handleStickyTabBar);
    window.addEventListener('resize', setStickyTabBarHeight);
});